var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.textoResumen)?_c('div',{staticClass:"summary--text"},[_c('v-card',{class:{'v-card_small':!_vm.stateGraphic}},[_c('label',{staticClass:"container-card summary--text_title"},[_vm._v("Resumen de la "+_vm._s(_vm.nombreResumen)+" ")]),_vm._v(" "),_c('v-textarea',{staticClass:"inputTexto mt-5",attrs:{"disabled":"","rows":"1","auto-grow":"","rounded":"","dense":""},model:{value:(_vm.textoResumen),callback:function ($$v) {_vm.textoResumen=$$v},expression:"textoResumen"}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e4e0d2c","hasScoped":true,"buble":{"transforms":{}}}!./src/components/Terapias/SummaryText/SummaryText.html
// module id = 1173
// module chunks = 0